module.exports = __webpack_public_path__ + "static/media/clipboard.dc7e38bd.svg";